import { ActionTree } from 'vuex'
import { RootState } from '../../types'
import { ServiceState } from './types'
import api from '@/lib/calendesk-js-library/api/api'
import { plainToClass } from 'class-transformer'
import Service from '@/calendesk/models/DTO/Response/Service'

export const actions: ActionTree<ServiceState, RootState> = {
  fetch ({ commit }, data: Record<string, any>): Promise<Service[]> {
    return new Promise((resolve, reject) => {
      api.services(data)
        .then((response: any) => {
          const services = plainToClass(Service, response.data.data as Service[])
          commit('SET_SERVICES', services)
          resolve(services)
        })
        .catch((error: any) => {
          reject(error)
        })
    })
  }
}
